import React, { useState, useEffect } from 'react';
import backgroundImage from '../assets/image6.jpg';
import maskImage from '../assets/gimage1.gif';

function Contact() {
  const [showMask, setShowMask] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMask(false);
    }, 5800); // 6 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-black"> {/* Added bg-black here */}
      <div
        className="absolute inset-0 w-full h-full transition-all duration-300 bg-black" /* Added bg-black here too */
        style={{
          backgroundImage: `url(${backgroundImage})`,
          ...(showMask && {
            WebkitMaskImage: `url(${maskImage})`,
            maskImage: `url(${maskImage})`,
            WebkitMaskSize: 'cover',
            maskSize: 'cover',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
          }),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Black background section with contact text */}
      <div className="absolute bottom-0 w-full bg-black text-white py-12 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-lg mb-6">
            For any questions, feedback, or assistance,
            <br />
            feel free to reach out to us through this email
          </p>
          
          <div className="h-4" />
          
          <a 
            href="mailto:confesz@tech-center.com"
            className="text-slate-400 hover:text-slate-300 clickable transition-colors duration-300 underline underline-offset-2"
          >
            confesz@tech-center.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;